/**
 * Grilla de categorias destacadas de la portada (ADM-06).
 *
 * Cada tarjeta es un enlace `<a>` cuyo texto es el nombre de la categoria: es
 * lo que hace que el catalogo sea recorrible desde la portada, tanto por una
 * persona como por un robot (SEO-01).
 */
import { Link } from 'react-router-dom';

import type { CategoriaDestacada } from '@elcarpintero/compartido';

import { numero } from '../../utilidades/formato';
import { rutas } from '../../utilidades/rutas';
import { FotoProducto } from '../comunes/Imagen';

/** Columnas de 168 px o más (`inicio.css`). */
const TAMANOS_CATEGORIA = '(max-width:720px) 50vw, 220px';

export interface GrillaCategoriasProps {
  categorias: CategoriaDestacada[];
}

export function GrillaCategorias({ categorias }: GrillaCategoriasProps) {
  return (
    <ul className="grilla-cat">
      {categorias.map((categoria) => (
        <li key={categoria.id}>
          <Link className="cat-tarjeta" to={rutas.categoria(categoria.slug)}>
            <span className="im">
              <FotoProducto
                imagen={categoria.imagen}
                nombre={categoria.nombre}
                tamanos={TAMANOS_CATEGORIA}
              />
            </span>
            <span className="tx">
              <span className="n">{categoria.nombre}</span>
              <span className="c">{numero(categoria.cantidadProductos)} productos</span>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
